export function readClientAuthToken(): string | null {
  if (typeof window === "undefined") return null;
  try {
    const committed = window.localStorage.getItem("auth_token")?.trim();
    if (committed) return committed;
  } catch {
    // ignore
  }
  try {
    const pending = window.sessionStorage
      .getItem("signin_pending_auth_token")
      ?.trim();
    if (pending) return pending;
  } catch {
    // ignore
  }
  return null;
}

export function authHeadersForJson(): Record<string, string> {
  const token = readClientAuthToken();
  if (!token) return {};
  const clean = token.startsWith("Bearer ") ? token.slice(7) : token;
  return { Authorization: `Bearer ${clean}` };
}

